module.exports = "<div class=\"message {{color}}\">\n  <ng-content></ng-content>\n</div>\n<div class=\"loader {{color}}\">\n  <div></div>\n  <div></div>\n  <div></div>\n  <div></div>\n  <div></div>\n  <div></div>\n  <div></div>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/circular-loader/circular-loader.component.html
// module id = 490
// module chunks = 1